import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {ErrorType} from "config/errors";

import {ErrorPayload, supportWebformApi} from "webform/api";

import {SupportContactFormService} from "webform/gen/supportContactForm";

export const getActiveCitiesList = createAsyncThunk("webform/geo/getActiveCitiesList", async (_, {rejectWithValue}) => {
    try {
        return await supportWebformApi.activeCitiesList();
    } catch (err) {
        return rejectWithValue(err);
    }
});

interface GeoState {
    cities: SupportContactFormService.CityItem[] | null;
    error?: ErrorType;
}

export const initialState: GeoState = {
    cities: null,
};

export const slice = createSlice({
    name: "geo",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getActiveCitiesList.fulfilled, (state, action) => {
            state.cities = action.payload.cities;
            state.error = undefined;
        });
        builder.addCase(getActiveCitiesList.rejected, (state, action) => {
            const typedPayload = action.payload as ErrorPayload;

            if (typedPayload.response?.error_data?.expiredAt) {
                state.error = ErrorType.TOKEN_EXPIRED;
            } else {
                state.error = ErrorType.GET_CITIES_FETCH_FAILED;
            }
        });
        builder.addCase(getActiveCitiesList.pending, (state) => {
            state.cities = null;
            state.error = undefined;
        });
    },
});

export default slice.reducer;
